import React, { Component } from "react";
import { connect } from "react-redux";
import URLSearchParams from 'url-search-params'
import { Redirect, Route, Switch, Router } from "react-router-dom";
import { LocaleProvider } from "antd";
import { IntlProvider } from "react-intl";
import './index.scss'
import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import { setInitUrl } from "appRedux/actions/Auth";
import { onLayoutTypeChange, onNavStyleChange, setThemeType } from "appRedux/actions/Setting";
import termsPhoto from '../../landing/pic/terms.svg'
import aboutUsPhoto from '../../landing/pic/about.svg'
import FAQPhoto from '../../landing/pic/FAQ.svg'
import permissionPhoto from '../../landing/pic/permission.svg'
import paytimePhoto from '../../landing/pic/pay.svg'
import affiliatePhoto from '../../landing/pic/invite.svg'
import contactUsPhoto from '../../landing/pic/contactus.svg'
import { getWithOutAuth, responseValidator } from "../../api";
import { toast } from "react-toastify";
import {
    LAYOUT_TYPE_BOXED,
    LAYOUT_TYPE_FRAMED,
    LAYOUT_TYPE_FULL,
    NAV_STYLE_ABOVE_HEADER,
    NAV_STYLE_BELOW_HEADER,
    NAV_STYLE_DARK_HORIZONTAL,
    NAV_STYLE_DEFAULT_HORIZONTAL,
    NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";
import Landing from "../../landing/landing";
import StaticPageTemplate from "../../landing/staticPage.template.index";
import StaticPageData from "../../landing/dataStatic.index";
import Footer from "../../landing/Footer/Footer";
import ContactUs from "../../landing/contactUs/contactUs.index";
import Authorization from "../../authorization/authorization.index";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import TestAPI from "../../testAPI/testAPI.index";
import CEUser from "../../routes/Admin/user/user.index";
import AllPricePage from "../../landing/allPrice/allPrice.index";
import Loading from "../../loading/loading.index";
import { post } from "../../api";
import VerifyOrder from "../../landing/verifyOrder/verifyOrder";


class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contents: [],
        }
    }



    setNavStyle = (navStyle) => {
        if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
            navStyle === NAV_STYLE_DARK_HORIZONTAL ||
            navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
            navStyle === NAV_STYLE_ABOVE_HEADER ||
            navStyle === NAV_STYLE_BELOW_HEADER) {
            document.body.classList.add('full-scroll');
            document.body.classList.add('horizontal-layout');
        } else {
            document.body.classList.remove('full-scroll');
            document.body.classList.remove('horizontal-layout');
        }
    };

    setLayoutType = (layoutType) => {
        if (layoutType === LAYOUT_TYPE_FULL) {
            document.body.classList.remove('boxed-layout');
            document.body.classList.remove('framed-layout');
            document.body.classList.add('full-layout');
        } else if (layoutType === LAYOUT_TYPE_BOXED) {
            document.body.classList.remove('full-layout');
            document.body.classList.remove('framed-layout');
            document.body.classList.add('boxed-layout');
        } else if (layoutType === LAYOUT_TYPE_FRAMED) {
            document.body.classList.remove('boxed-layout');
            document.body.classList.remove('full-layout');
            document.body.classList.add('framed-layout');
        }
    };


    componentWillMount() {

        if (!window.location.toString().includes('userpanel')) {
            getWithOutAuth('/Content/GetAll',).then((res) => {
                if (responseValidator(res.status)) {
                    console.log('res ', res);

                    this.setState({ contents: res.data.data });
                    localStorage.setItem('testContent', true)
                }
                else if (res.message)
                    toast.error(res.data.message)

            })
        }
        if (this.props.initURL === '') {
            this.props.setInitUrl(this.props.history.location.pathname);
        }
        const params = new URLSearchParams(this.props.location.search);

        if (params.has("theme")) {
            this.props.setThemeType(params.get('theme'));
        }
        if (params.has("nav-style")) {
            this.props.onNavStyleChange(params.get('nav-style'));
        }
        if (params.has("layout-type")) {
            this.props.onLayoutTypeChange(params.get('layout-type'));
        }
    }

    render() {

        const { match, location, layoutType, navStyle, locale, authUser, initURL } = this.props;



        console.log(this.state.contents);

        if (location.pathname === '/') {
            if (authUser === null) {
                // return (<Redirect to={'/landing'}/>);
                return <Landing />
            } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
                return (<Redirect to={'/main/dashboard/crypto'} />);
            } else {
                return (<Redirect to={initURL} />);
            }
        }
        this.setLayoutType(layoutType);
        this.setNavStyle(navStyle);


        const currentAppLocale = AppLocale[locale.locale];
        return (
            <LocaleProvider locale={currentAppLocale.antd}>

                <IntlProvider
                    locale={currentAppLocale.locale}
                    messages={currentAppLocale.messages}>
                    <Switch>
                        <Route exact path='/testAPI' component={TestAPI} />
                        <Route exact path='/authorization/:id?' component={Authorization} />
                        <Route exact path='/landing' component={Landing} />
                        <Route path={`/page/`}>
                            <div className="TMEX-landing-container">
                                <StaticPageTemplate />
                                <div className="TMEX-landing-content">
                                    <Switch>
                                        <Route exact path={'/page/about'}>
                                            <StaticPageData title='درباره ما' image={aboutUsPhoto}>
                                                <div>
                                                    {

                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[4].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/allprice'}>
                                            <AllPricePage />
                                        </Route>
                                        <Route path={'/page/verify'}>
                                            <VerifyOrder />
                                        </Route>
                                        <Route path={'/page/contact'}>
                                            <StaticPageData title='ارتباط با ما' image={contactUsPhoto}>
                                                <ContactUs content={<div>
                                                    {
                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[1].text
                                                        }} />

                                                    }
                                                </div>} />
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/affiliate'}>
                                            <StaticPageData title='کسب درآمد' image={affiliatePhoto}>
                                                <div>
                                                    {
                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[0].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/permission'}>
                                            <StaticPageData title='سطوح کاربری' image={permissionPhoto}>
                                                <div>
                                                    {
                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[5].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/FAQ'}>
                                            <StaticPageData title='سوالات متداول' image={FAQPhoto}>
                                                <div>
                                                    {

                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[6].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/laws'}>
                                            <StaticPageData title='قوانین و مقررات' image={termsPhoto}>
                                                <div>
                                                    {

                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[7].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                        <Route path={'/page/paytime'}>
                                            <StaticPageData title={'زمان تسویه حساب'} image={paytimePhoto}>
                                                <div>
                                                    {
                                                        this.state.contents.length !== 0 &&
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: this.state.contents[2].text
                                                        }} />

                                                    }
                                                </div>
                                            </StaticPageData>
                                        </Route>
                                    </Switch>

                                </div>
                                <div className='TMEX-landing-footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Route>
                        <Route path={`${match.url}`} component={MainApp} />
                        <Route path='*' component={Landing} />
                    </Switch>

                </IntlProvider>
            </LocaleProvider>
        )
    }
}

const mapStateToProps = ({ settings, auth }) => {
    const { locale, navStyle, layoutType } = settings;
    const { authUser, initURL } = auth;
    return { locale, navStyle, layoutType, authUser, initURL }
};
export default connect(mapStateToProps, { setInitUrl, setThemeType, onNavStyleChange, onLayoutTypeChange })(App);
